import(/* webpackMode: "eager" */ "/tmp/build_d40485d4/web/src/app/global-error.tsx")